import { render, staticRenderFns } from "./CourseModal.vue?vue&type=template&id=b842fe3e&scoped=true"
import script from "./CourseModal.vue?vue&type=script&lang=js"
export * from "./CourseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b842fe3e",
  null
  
)

export default component.exports